// Carry Roll Validation — PSD §11.7. Returns ValidationWarning[] for guardrail ranges.
import { RANGE_ALTITUDE_M, RANGE_BALL_SPEED, RANGE_CLUB_SPEED, RANGE_LAUNCH_ANGLE_RAD, RANGE_SMASH, RANGE_SPIN_RPM, RANGE_TEMPERATURE_K, RANGE_WIND_MS, } from './constants';
import { radToDeg } from './units';
/** Validate every field's range/missing/implausible state. */
export function validate(request) {
    const w = [];
    const l = request.launch;
    const e = request.environment;
    // Required fields
    if (!Number.isFinite(l.ballSpeed) || l.ballSpeed <= 0) {
        w.push({ field: 'launch.ballSpeed', code: 'missing', message: 'Ball speed is required.' });
    }
    else if (l.ballSpeed < RANGE_BALL_SPEED[0] || l.ballSpeed > RANGE_BALL_SPEED[1]) {
        w.push({
            field: 'launch.ballSpeed',
            code: 'range',
            message: `Ball speed ${l.ballSpeed.toFixed(1)} m/s is outside ${RANGE_BALL_SPEED[0]}–${RANGE_BALL_SPEED[1]} m/s.`,
        });
    }
    if (!Number.isFinite(l.launchAngle)) {
        w.push({ field: 'launch.launchAngle', code: 'missing', message: 'Launch angle is required.' });
    }
    else if (l.launchAngle < RANGE_LAUNCH_ANGLE_RAD[0] || l.launchAngle > RANGE_LAUNCH_ANGLE_RAD[1]) {
        w.push({
            field: 'launch.launchAngle',
            code: 'range',
            message: `Launch angle ${radToDeg(l.launchAngle).toFixed(1)}° is outside ${radToDeg(RANGE_LAUNCH_ANGLE_RAD[0])}°..${radToDeg(RANGE_LAUNCH_ANGLE_RAD[1])}°.`,
        });
    }
    if (!Number.isFinite(l.spinRpm) || l.spinRpm < 0) {
        w.push({ field: 'launch.spinRpm', code: 'missing', message: 'Spin rate is required.' });
    }
    else if (l.spinRpm > RANGE_SPIN_RPM[1]) {
        w.push({
            field: 'launch.spinRpm',
            code: 'range',
            message: `Spin rate ${l.spinRpm} rpm exceeds ${RANGE_SPIN_RPM[1]} rpm.`,
        });
    }
    if (l.clubSpeed != null && (l.clubSpeed < RANGE_CLUB_SPEED[0] || l.clubSpeed > RANGE_CLUB_SPEED[1])) {
        w.push({
            field: 'launch.clubSpeed',
            code: 'range',
            message: `Club speed ${l.clubSpeed.toFixed(1)} m/s is outside ${RANGE_CLUB_SPEED[0]}–${RANGE_CLUB_SPEED[1]} m/s.`,
        });
    }
    // Smash factor implausibility
    if (l.clubSpeed != null && l.clubSpeed > 0 && l.ballSpeed > 0) {
        const smash = l.ballSpeed / l.clubSpeed;
        if (smash > RANGE_SMASH[1]) {
            w.push({
                field: 'launch.smash',
                code: 'implausible',
                message: `Smash factor ${smash.toFixed(2)} exceeds the realistic ${RANGE_SMASH[1]} limit.`,
            });
        }
    }
    // Environment ranges
    if (e.altitudeM < RANGE_ALTITUDE_M[0] || e.altitudeM > RANGE_ALTITUDE_M[1]) {
        w.push({
            field: 'environment.altitudeM',
            code: 'range',
            message: `Altitude ${e.altitudeM} m is outside ${RANGE_ALTITUDE_M[0]}–${RANGE_ALTITUDE_M[1]} m.`,
        });
    }
    if (e.temperatureK < RANGE_TEMPERATURE_K[0] || e.temperatureK > RANGE_TEMPERATURE_K[1]) {
        w.push({
            field: 'environment.temperatureK',
            code: 'range',
            message: `Temperature ${(e.temperatureK - 273.15).toFixed(0)}°C is outside the realistic range.`,
        });
    }
    if (e.windSpeed < RANGE_WIND_MS[0] || e.windSpeed > RANGE_WIND_MS[1]) {
        w.push({
            field: 'environment.windSpeed',
            code: 'range',
            message: `Wind speed ${e.windSpeed} m/s is outside ${RANGE_WIND_MS[0]}–${RANGE_WIND_MS[1]} m/s.`,
        });
    }
    return w;
}
//# sourceMappingURL=validate.js.map